import { Box, Button, Typography } from "@mui/material";
import { IconDownload, IconPrinter } from "@tabler/icons-react";
import { useIntl } from "react-intl";
import type { QrProducto } from "../types/catalogoInventario.types";
import { COLORES_INVENTARIO } from "../constants/catalogoInventario.constants";
import { descargarQr, imprimirQr } from "../utils/qrProducto.utils";

export const QrProductoTarjeta = ({ qr }: { qr: QrProducto }): JSX.Element => {
    const intl = useIntl();

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 1,
                p: 2,
                mx: 2,
                mb: 2,
                border: `1px dashed ${COLORES_INVENTARIO.qr}`,
                borderRadius: 2,
            }}
        >
            <img src={qr.urlImagen} alt={qr.clave} style={{ width: 220, height: "auto" }} />
            <Box sx={{ display: "flex", gap: 1 }}>
                <Button
                    variant="contained"
                    size="small"
                    sx={{ color: "#fff", background: COLORES_INVENTARIO.boton }}
                    startIcon={<IconDownload size={18} />}
                    onClick={() => descargarQr(qr)}
                >
                    {intl.formatMessage({ id: "general_descargar", defaultMessage: "Descargar" })}
                </Button>
            </Box>
        </Box>
    );
};
